import React, { useState } from "react";
import { useHistory } from "react-router-dom";
import Header from "../../../components/molecules/Header";
import Tabs from "@material-ui/core/Tabs";
import Tab from "@material-ui/core/Tab";
import TabPanel from "../../../components/TabPanel";
import useStyles from "./style";

function a11yProps(index) {
  return {
    id: `full-width-tab-${index}`,
    "aria-controls": `full-width-tabpanel-${index}`,
  };
}

function Cara({ value }) {
  return (
    <TabPanel value={value} index="cara">
      tes
    </TabPanel>
  );
}

function Syatat({ value }) {
  return (
    <TabPanel value={value} index="syarat">
      tes syart
    </TabPanel>
  );
}

function CheckIn() {
  const classes = useStyles();
  const history = useHistory();
  const [tabValue, setTabValue] = useState("cara");

  const [tabs, setTabs] = useState([
    {
      label: "Cara mengikuti",
      value: "cara",
    },
    {
      label: "Syarat & Ketentuan",
      value: "syarat",
    },
  ]);

  const handleChange = (event, value) => {
    setTabValue(value);
  };
  return (
    <>
      <Header
        type="with-title"
        title="Tentang daily check-in"
        onClick={() => history.push("/tokoramepoint")}
      />

      <div className={classes.wrapRiwayat}>
        <Tabs
          variant="fullWidth"
          aria-label="full width tabs example"
          textColor="primary"
          value={tabValue || "about"}
          onChange={handleChange}
          TabIndicatorProps={{
            style: {
              background: "rgb(86,117,211)",
              background:
                "linear-gradient(90deg, rgba(86,117,211,1) 70%, rgba(249,163,61,1) 70%, rgba(249,163,61,1) 90%, rgba(244,84,141,1) 90%)",
            },
          }}
          size="small"
        >
          {tabs.map((tab) => (
            <Tab
              className={classes.tab}
              key={tab.value}
              label={tab.label}
              value={tab.value}
              {...a11yProps(tab.value)}
            />
          ))}
        </Tabs>
        <Cara value={tabValue} />
        <Syatat value={tabValue} />
      </div>
    </>
  );
}

export default CheckIn;
